import axios from 'axios'
import http from '@/services/http'
import { setRouteTaskToList, unsetRouteTaskFromList } from '@/utils/sharedOrdersMutations'

let cancelMainInfoSrc = null

/**
 * для обнуления фильров из компонентов
 */
export const getDefaultFilters = () => ({
  search: '',
  /* string[] */
  statuses: [],
  /* { id, title, value }[] */
  paymentTypes: [],
  /* { courier_id, first_name, last_name, native, is_foot_courier } */
  couriers: [],
  sort: '',
  auto_routetask: []
})

export default {
  namespaced: true,
  state: {
    /**
     * [
     *  {
     *    "id": 0,
     *    "title": "string",
     *    "limits": {}
     *   }
     * ]
     */
    workshopsInfo: [],
    /**
     * [
     *  {
     *    "workshop_id": 0,
     *    "loads": 0
     *  }
     * ]
     */
    workshopLoads: [],
    orderPayments: null,
    ordersByStatuses: null,
    cashbox: null,
    /**
     * data: Array,
     * count: number
     */
    orders: {
      data: [],
      count: 0
    },
    /**
     * { payment_types: string[]; statuses: string[], sort[] }
     */
    allowedOrdersFilters: {
      paymentTypes: [],
      statuses: []
    },
    filters: getDefaultFilters()
  },
  getters: {
    getWorkshopLoadObjById(state) {
      return workshopId => state.workshopLoads.find(obj => obj.workshop_id === workshopId)
    },
    getWorkshopColor(state, getters) {
      return workshopId => {
        const workshopInfo = state.workshopsInfo.find(obj => obj.id === workshopId)
        const loadInfo = getters.getWorkshopLoadObjById(workshopId)
        if (!workshopInfo || !loadInfo) {
          return 'green'
        }
        const { limits } = workshopInfo
        const { loads } = loadInfo
        if (loads <= limits.green_limit) {
          return 'green'
        }
        if (loads <= limits.yellow_limit) {
          return 'yellow'
        }
        return 'red'
      }
    }
  },
  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = orders
    },
    /**
     * SET_ROUTE_TASK и UNSET_ROUTE_TASK
     * вызывается из модуля routeTasks
     */
    SET_ROUTE_TASK(state, routeTaskData) {
      setRouteTaskToList(state.orders.data, routeTaskData)
    },
    UNSET_ROUTE_TASK(state, orderIds) {
      unsetRouteTaskFromList(state.orders.data, orderIds)
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    SET_WORKSHOPS_INFO(state, workshopsInfo) {
      state.workshopsInfo = workshopsInfo
    },
    SET_WORKSHOP_LOADS(state, workshopLoads) {
      state.workshopLoads = workshopLoads
    },
    SET_ORDERS_PAYMENTS(state, orderPayments) {
      state.orderPayments = orderPayments
    },
    SET_ORDERS_BY_STATUSES(state, ordersByStatuses) {
      state.ordersByStatuses = ordersByStatuses
    },
    SET_ORDERS_CASHBOX(state, cashbox) {
      state.cashbox = cashbox
    },
    UPDATE_ORDER_START_TIME(state, { orderId, data: { start_time } }) {
      const orderIndex = state.orders.data.findIndex(o => o.id === orderId)
      if (orderIndex !== -1) {
        const order = state.orders.data[orderIndex]
        order.times.start_at = start_time
        order.preorder_manual_control = true
      }
    },
    SET_ALLOWED_ORDERS_FILRTERS(state, allowedOrdersFilters) {
      state.allowedOrdersFilters = allowedOrdersFilters
    }
  },
  actions: {
    async getMainInfo({ state, commit, rootState }) {
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelMainInfoSrc = source
      const manufactureId = rootState.manufactures.selectedManufacture.id
      const sendedFilters = {
        search: state.filters.search,
        sort: state.filters.sort,
        /**
         * следующие поля будут строками разделенными запятой,
         * по условиям, описанным ниже
         */
        statuses: state.filters.statuses,
        payment_types: state.filters.paymentTypes,
        couriers_ids: state.filters.couriers,
        auto_routetask: state.filters.auto_routetask
      }
      Object.keys(sendedFilters).forEach(key => {
        if (sendedFilters[key] === '') {
          delete sendedFilters[key]
        }

        if (Array.isArray(sendedFilters[key])) {
          if (sendedFilters[key].length === 0) {
            delete sendedFilters[key]
          } else {
            switch (key) {
              case 'payment_types':
                sendedFilters[key] = sendedFilters[key].map(item => item.value).join(',')
                break
              case 'couriers_ids':
                sendedFilters[key] = sendedFilters[key].map(item => item.courier_id).join(',')
                break
              case 'auto_routetask': {
                const values = sendedFilters[key].map(item => item.value)
                if (values.length === 1) {
                  sendedFilters[key] = values[0].toString()
                } else {
                  delete sendedFilters[key]
                }
                break
              }
              default:
                sendedFilters[key] = sendedFilters[key].join(',')
            }
          }
        }
      })
      const res = await http.get(`main/${manufactureId}`, {
        params: sendedFilters,
        cancelToken: source.token
      })
      commit('SET_ORDERS', res.orders)
      commit('SET_WORKSHOP_LOADS', res.workshop_loads)
      commit('SET_ORDERS_PAYMENTS', res.orders_payments)
      commit('SET_ORDERS_BY_STATUSES', res.orders_statuses)
      commit('SET_ORDERS_CASHBOX', res.cashbox)
      /**
       * Все кроме курьеров
       */
      commit('SET_ALLOWED_ORDERS_FILRTERS', res.filters)
      /**
       * У курьеров отдельный стейт, с методами их изменения,
       * поэтому их запипишем из фильтров отдельно
       */
      commit('couriers/SET_COURIERS', res.filters.couriers, { root: true })
    },
    cancelMainInfo() {
      if (cancelMainInfoSrc) {
        cancelMainInfoSrc.cancel()
      }
    },
    /**
     * manufactureId передается из компонента, так как может быть из разных
     * источников. См компонент order-detail
     */
    async getOrderDetail(store, { orderId, manufactureId }) {
      const res = await http.get(`manufacture/${manufactureId}/order/${orderId}`)
      return res
    },
    /**
     * data: { action, start_time? (при action === 'modify_start_time') }
     */
    async updateOrder({ commit, rootState }, { orderId, data }) {
      const manufactureId = rootState.manufactures.selectedManufacture.id
      const res = await http.patch(`manufacture/${manufactureId}/order/${orderId}`, { ...data })
      if (data.action === 'modify_start_time') {
        commit('UPDATE_ORDER_START_TIME', { orderId, data })
      }
      return res
    },
    async getWorkshopsInfo({ commit, rootState }) {
      const manufactureId = rootState.manufactures.selectedManufacture.id
      const res = await http.get(`manufacture/${manufactureId}/workshops`)
      commit('SET_WORKSHOPS_INFO', res)
    },
    async printInvoice(store, orderId) {
      await http.post(`order/${orderId}/printing`, {
        action: 'invoice'
      })
    },
    async printStickers(store, orderId) {
      await http.post(`order/${orderId}/printing`, {
        action: 'stickers'
      })
    },
    async printItemSticker(store, itemId) {
      await http.post(`order_item/${itemId}/print_sticker`)
    },
    async printComboSticker(store, itemId) {
       await http.post(`order_combo/${itemId}/print_sticker`)
    },
    async getOrderHistory(store, orderId) {
      const res = await http.get(`history/order/${orderId}`)
      return res
    }
  }
}
